import { DatePipe } from '@angular/common';
import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { HasPermissionDirective } from '@ipg/ngx-frontend-toolset';
import { UnitResponseModel } from '../../units.model';

@Component({
  selector: 'app-unit-card',
  imports: [
    MatIcon,
    MatIconButton,
    MatTooltip,
    MatDivider,

    DatePipe,
    HasPermissionDirective,
  ],
  templateUrl: './unit-card.component.html',
  styleUrl: './unit-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'group',
    '[class.active]': 'active()',
  },
})
export class UnitCardComponent {
  public readonly data = input.required<UnitResponseModel>();

  public readonly active = input(false, { transform: booleanAttribute });
  public readonly disabled = input(false, { transform: booleanAttribute });
  public readonly main = input(false, { transform: booleanAttribute });
  public readonly dimmed = input(false, { transform: booleanAttribute });
  public readonly highlighted = input(false, { transform: booleanAttribute });

  public readonly addUnit = output<'top' | 'bottom'>();
  public readonly activate = output<UnitResponseModel>();
  public readonly restore = output<UnitResponseModel>();

  protected handleActivate(): void {
    if (!this.disabled()) {
      this.activate.emit(this.data());
    }
  }

  protected handleRestore(): void {
    this.restore.emit(this.data());
  }
}
